// export const ScrollPositionContext = React.createContext(0);

import React from 'react';

export const ScrollPositionContext = React.createContext({
  scrollPosition: 0,
  scrolling: false
});
